export default __webpack_public_path__ + "99f5098b05a8e977b1c26ba6886190ec.png";